import { GetParams } from '../Helper';
import { GetBranchLocationsByDeveloperIdAPI } from '../Services';

let timer = null;

export const BranchLocationRule = async (item, value, onItemChanged) => {
  if (!item?.data?.searchKey || item.data.searchKey !== 'branch_location')
    return;

  if (timer !== null) clearTimeout(timer);

  timer = setTimeout(async () => {
    const res = await GetBranchLocationsByDeveloperIdAPI(+GetParams('id'), {
      pageIndex: 1,
      pageSize: 100,
      name: value,
    });

    if (!res || !res.result) return;

    item.data.enum = res.result.map((branch) => ({
      id: branch.branchesLocationId,
      name: branch.branchName,
    }));
    onItemChanged(item.data.enum);
  }, 500);
};

export const BranchLocationRule2 = (item, value, onValueChanged, itemIndex) => {
  if (!value) return;

  const fieldId = item?.field?.id;
  onValueChanged(value, itemIndex, fieldId);
};
